<template>
    <layout-machine-introduction :unsaved-puri-count="unsavedPuriCount"
                                 :latest-image-id="latestImageId"
                                 :is-searchable="false"
                                 :machine-id="machineId"
                                 :section-title-list="sectionTitleList"
                                 :has-top-border-anchor-link="false"
                                 :has-title-anchor-link="false"
                                 :has-border-anchor-link="false"
                                 :has-movie-title="false"
    >
        <template v-slot:content-campaign>
            <div v-if="informationItems.length" class="information">
                <img v-if="informationItems.length === 1" :src="buildImgUrl('information_back.png')" alt="information">
                <img v-else :src="buildImgUrl('information_back_2items.png')" alt="information">
                <div class="information-items">
                    <a v-for="item in informationItems"
                       :key="item.key"
                       @click="transitionPage(item.url, item.text, '_blank')"
                       :data-jest="`information-item-${item.key}`">
                        <img :class="item.imgClass" :src="buildImgUrl(item.imgUrl)" :alt="item.text">
                    </a>
                </div>
            </div>
            <div class="oyako-guide">
                <img :src="buildImgUrl('oyako_guide.png')" alt="シールだけじゃない！プリの画像を全部もらう方法">
                <a class="oyako-guide-btn" @click="transitionPage('https://sp.pictlink.com/sp/s/AqoAQIGQ', '詳しくはこちら！', '_blank')">
                    <img :src="buildImgUrl('oyako_guide_btn.png')" alt="詳しくはこちら！">
                </a>
            </div>
        </template>
        <template v-slot:feature-summary>
            <img v-if="isXRPublished" :src="buildImgUrl('feature_summary_2.png')" alt="PURICOの基本情報">
            <img v-else :src="buildImgUrl('feature_summary_1.png')" alt="PURICOの基本情報">
        </template>
        <template v-slot:content-1>
            <div class="cont-01">
                <img class="img-01" :src="buildImgUrl('contents01_01.png')"
                     alt="こだわりコーデを可愛く残せちゃう♡ハデカワ背景が盛り沢山！">
                <img class="img-02" :src="buildImgUrl('contents01_02.gif')"
                     alt="カベと床を自由にカスタムできる新機能も登場！">
            </div>
        </template>
        <template v-slot:content-2>
            <img class="img-01" :src="buildImgUrl('contents02_01.png')"
                 alt="限定のスペシャルスタンプや憧れの可愛いヘアカラーを試せる新機能が盛りだくさん！">
            <img class="img-02" :src="buildImgUrl('contents02_02.png')"
                 alt="とことん派手可愛くデコっちゃおう♡">
        </template>
        <template v-slot:content-3>
            <img class="img-01" :src="buildImgUrl('contents03_01.png')"
                 alt="PURICOだけのランダムガチャが登場！！全5セット 落書きで使える限定スタンプやシールデザインがGETできるよ！">
            <img class="img-02" :src="buildImgUrl('contents03_02.png')"
                 alt="▼Lineup あまくてかわいいセット 定番しなこセット おかし食べたら歯磨きセット">
            <img class="img-03" :src="buildImgUrl('contents03_03.png')"
                 alt="レッツ虫歯タイムセット secret">
        </template>
        <template v-slot:content-4>
            <img class="img-01" :src="buildImgUrl('contents04_01.png')"
                 alt="撮ったプリがぜんぶ印刷されて嬉しい♡おまけ部分はプリ帳に貼ったりお友達と交換してね！">
        </template>
        <template v-slot:content-5>
            <img class="img-01" :src="buildImgUrl('contents05_01.png')"
                 alt="ほんのり色づくリップ＆チーク パッと目を惹く鮮やかテイスト 簡単タッチで完成するメイクセットもあるよ！">
        </template>
    </layout-machine-introduction>
</template>

<script>
import LayoutMachineIntroduction from "../../templates/LayoutMachineIntroduction.vue";
import * as urlUtil from "../../../util/UrlUtil";
import {mapActions, mapGetters} from "vuex";
import {getClickAllEvent} from "../../../util/Ga4EventUtil";

export default {
    name: "MachineHypershot2",
    components: {LayoutMachineIntroduction},
    data() {
        return {
            machineId: 172,
            sectionTitleList: [
                '1 ハデカワ空間で思い切り撮影を楽しめる！「上から全身ショット」',
                '2 落書きがもっと楽しくなる♡「ハデカワ落書き」',
                '3 何が出るかドキドキワクワク！「ランダムガチャ」',
                '4 プリ帳・プリ交換におすすめ「ぜんぶ印刷シール」',
                '5 ハデカワな世界観にぴったり「鮮やかキュートな写り」',
            ]
        }
    },
    props: {
        /**
         * Headerコンポーネント用
         * 未保存プリ数
         */
        unsavedPuriCount: {
            type: String,
            required: true
        },
        /**
         * Headerコンポーネント用
         * 最新プリID
         */
        latestImageId: {
            type: String,
            required: true
        },
        /**
         * 当該機種が「遊べるお店を探す」によって検索可能であるかどうかを判定する.
         * toolboxから取得
         * 「遊べるお店を探す」表示判定
         */
        isSearchable: {
            type: Boolean,
            required: true
        },
    },
    computed: {
        ...mapGetters({
            accountStatus: 'AccountStoreV2/accountStatus'
        }),
        isShopListPublished() {
            return this.accountStatus && this.accountStatus.timeTripDate.isInTime("2026-06-11T00:00:00", "2026-11-02T00:00:00")
        },
        /**
         * 「遊べるお店はこちら！」ボタン表示判定
         * 通常はpropsのisSearchableをLayoutMachineIntroduction.vueに渡して同コンポーネント側でボタンを表示しますが、
         * 今回は一時期非表示にするイレギュラー仕様かつinformation内に並べて表示するため、
         * LayoutMachineIntroduction.vueにはfalseを渡し、こちらの値でinformationItemsへの追加を制御しています
         */
        isShopSearchable() {
            return this.isSearchable && !this.isShopListPublished
        },
        /**
         * PURICOのXR機能が情報公開されているか
         */
        isXRInformationDisclosure() {
            return this.accountStatus && this.accountStatus.timeTripDate.isAfterTime("2026-08-05T00:00:00")
        },
        /**
         * PURICOのXR機能がリリースされているか
         * PURICOのXR機能のリリースに合わせて証明プリについての記載も表示されるようにする
         */
        isXRPublished() {
            return this.accountStatus && this.accountStatus.timeTripDate.isAfterTime("2026-08-06T00:00:00")
        },
        /**
         * ショップリストのURL
         * PURICOのXR機能の情報公開に合わせてXR店舗記載版ショップリストが表示されるようにする
         */
        shopListUrl() {
            if(this.isXRInformationDisclosure){
                return 'https://sp.pictlink.com/sp/puri_news#/17390'
            } else {
                return 'https://sp.pictlink.com/sp/puri_news#/16990'
            }
        },
        /**
         * informationに表示するボタンリスト
         * keyは表示条件によって並び順が変わるためのv-forのkey兼data-jestの識別子(ボタンごとに一意)
         * imgClassは画像ごとの表示幅の補正用クラス(不要な場合はnull)
         */
        informationItems() {
            const items = [];

            if(this.isXRInformationDisclosure){
                items.push(
                    {
                        key: 'xr',
                        text: 'まるでリアル体験！しなこちゃんのXRプリが登場！',
                        url: 'https://sp.pictlink.com/sp/puri_news?from=17579_introductionlp#/17579',
                        imgUrl: 'btn_xr.png',
                        imgClass: null,
                    }
                )
            }
            if(this.isShopListPublished){
                items.push(
                    {
                        key: 'shop-list',
                        text: '撮れるお店はここ！',
                        url: this.shopListUrl,
                        imgUrl: 'btn_shop_list.png?v=20260713',
                        imgClass: null,
                    }
                );
            }
            if(this.isShopSearchable){
                items.push(
                    {
                        key: 'shop-search',
                        text: '遊べるお店はこちら',
                        url: urlUtil.servletUrlUtil.shopSearchUrl('PURICO'),
                        imgUrl: 'btn_shop.png',
                        imgClass: 'btn-shop-search',
                    }
                )
            }
            return items;
        },
    },
    mounted() {
        /**
         * TheHeader,TheFooterでstoreのaccountStatusを使用するため、予めstoreに保存しておく
         * FIXME:ここでの取得を忘れてもエラーが出ず気づかない可能性があるため、VOYAGERFRONT-5558で修正予定
         */
        this.getAccountStatus()
    },
    methods: {
        ...mapActions({
            getAccountStatus: 'AccountStoreV2/getAccountStatus'
        }),
        /**
         * 画像のURLを組み立てる
         * @param {string} imgName 画像名
         */
        buildImgUrl(imgName) {
            return urlUtil.imageUrlUtil.machineIntroductionImageUrl(String(this.machineId), imgName)
        },
        /**
         * cssのurl関数の呼び出し部分の含めた文字列を返す
         * styleタグ内でv-bindで使用することを想定している
         */
        buildStyleImgUrl(imageName) {
            const imgUrl = this.buildImgUrl(imageName)
            return `url(${imgUrl})`;
        },
        /**
         * GA4イベントを送信してから指定したページに遷移させる
         * @param {string} url elementUrl
         * @param {string} elementText elementText
         * @param {string} transitionTarget 別窓指定
         */
        transitionPage(url, elementText, transitionTarget) {
            getClickAllEvent(url, elementText)
            window.open(url, transitionTarget)
        },
    }
}
</script>

<style scoped lang="scss">
@use "sass:math";
@use "../../../../scss/v2/base/variables";

$deviceWidth: 750px;

:deep(*) {
    .c-machine-introduction {
        &-top {
            .content-campaign {
                .information {
                    position: relative;

                    .information-items {
                        position: absolute;
                        width: math.percentage(math.div(540px, $deviceWidth));
                        bottom: math.percentage(math.div(50px, $deviceWidth));
                        left: math.percentage(math.div(105px, $deviceWidth));
                        display: flex;
                        flex-direction: column;
                        gap: variables.$grid-consistent;

                        /**
                         * btn_shop.pngはLayoutMachineIntroduction共通のボタン画像(539x134)で、
                         * PURICO専用のbtn_xr.png/btn_shop_list.png(520x156)とは画像内の余白量が異なる。
                         * そのまま横幅100%で並べるとボタン部分の見た目の幅だけが約2%広くなるため、
                         * 他のボタンと見た目の幅が揃うよう520px相当まで縮めて中央寄せする
                         */
                        .btn-shop-search {
                            display: block;
                            width: math.percentage(math.div(520px, 540px));
                            margin: variables.$grid-consistent * 0.5 auto;
                        }
                    }
                }
                .oyako-guide {
                    background-color: variables.$color-machine-hypershot2;

                    &-btn {
                        display: block;
                    }
                }
            }
            .btn-shop-list {
                position: absolute;
                top: math.percentage(math.div(342px, $deviceWidth));
                left: 0;
                width: 100%;
                &-link {
                    width: math.percentage(math.div(528px, $deviceWidth));
                }
            }
            .list-anchor-link {
                padding-top: variables.$grid-consistent * 3;

                &-feature-summary {
                    width: math.percentage(math.div(600px, $deviceWidth));
                    margin: auto;
                }
            }
        }
        &-contents {
            .accordion-inner {
                .img-01, .img-02, .img-03, .img-04, .img-05 {
                    display: block;
                }
                .cont-01 {
                    position: relative;
                    .img-02 {
                        position: absolute;
                        top: math.percentage(math.div(576px, $deviceWidth));
                        left: math.percentage(math.div(304px, $deviceWidth));
                        width: math.percentage(math.div(142px, $deviceWidth));
                    }
                }
            }
        }
        &-movie {
            padding: variables.$grid-consistent * 3.5 0 variables.$grid-consistent * 3.5;
            background-image: v-bind("buildStyleImgUrl('movie_back.png')");
            background-repeat: no-repeat;
            background-position: center;
            background-size: cover;
            &-btn-studio {
                width: math.percentage(math.div(430px, $deviceWidth));
                margin: auto;
            }
        }
    }
}

</style>
